import {getLayers, businessOverview} from '../sql/queries';
import {tileNoLabel} from '../services/map';

export const  boundArray = [[-27.6603865819999, 152.679693133], [-27.021964587, 153.468488646]];
export const  panBoundArray = [[-27.5472497,151.5532438], [-27.021964587, 153.468488646]];
let defaultState = {
  profile: null,
  geom_table:  'lga',
  map: {
    zoom: 10,
  },
  boundArray: boundArray,
  geo_type : 'Local Government Area',
  geo_name: 'Brisbane (C)',
  sidebarData: [],
  populations: [],
  categories: [],
  geo_names: [{geo_name: 'Brisbane (C)'}],
  mapType: tileNoLabel.terrain,
  opacity: 1,
  detailView: false,
  detailChartData: null,
  detailTableData: null,
  mapTotal: null,
  overviewSummary: [],
  overviewChartSelected: 'output',
  businessOverview: {
    years: [],
    types: [],
    year: '2017',
    type: 'Total',
    table: []
  },
  economicModel: {
    multiplier: 1,
    multipliers: [],
    table: []
  }
};


export default defaultState;
//center: [-27.4543942,152.4184436],

export const populationForecast = {
  data: []
}


// WEBPACK FOOTER //
// ./src/data/state.js